import React from "react";
import { Group, Circle, Shape } from "react-konva";

export type DefenderGlyphProps = {
  x: number;
  y: number;
  angle?: number;      // en degrés
  color?: string;      // couleur principale (par défaut: rouge)
};

// Constantes de dessin (identiques à l’éditeur)
const DEF_DOT_R = 12;        // rayon du disque
const DEF_WING_LEN = 15;     // longueur horizontale d’un "bras"
const DEF_WING_RISE = 2;     // montée vers le haut (↑ = plus “ouvert”)
const DEF_WING_STROKE = 5;   // épaisseur du trait
const DEF_WING_GAP = 1;      // petit espace entre le disque et le bras

export const DefenderGlyph: React.FC<DefenderGlyphProps> = ({
  x,
  y,
  angle = 0,
  color = "#ef4444", // même rouge que dans PlayCreator
}) => {
  return (
    <Group x={x} y={y} rotation={angle} listening={false}>
      {/* disque */}
      <Circle radius={DEF_DOT_R} fill={color} />

      {/* bras gauche (Bézier) */}
      <Shape
        sceneFunc={(ctx, shape) => {
          const x0 = -(DEF_DOT_R + DEF_WING_GAP), y0 = 0;          // point tangent
          const x1 = x0 - DEF_WING_LEN,            y1 = -DEF_WING_RISE;
          const cx = x0 - DEF_WING_LEN * 0.55,     cy = -DEF_WING_RISE * 1.2;

          ctx.beginPath();
          ctx.lineCap = "round";
          ctx.moveTo(x0, y0);
          ctx.quadraticCurveTo(cx, cy, x1, y1);
          // @ts-ignore Konva définit stroke() au runtime
          ctx.strokeStyle = shape.stroke();
          // @ts-ignore
          ctx.lineWidth = shape.strokeWidth();
          ctx.stroke();
        }}
        stroke={color}
        strokeWidth={DEF_WING_STROKE}
        listening={false}
      />

      {/* bras droit (miroir) */}
      <Shape
        sceneFunc={(ctx, shape) => {
          const x0 =  (DEF_DOT_R + DEF_WING_GAP), y0 = 0;
          const x1 =  x0 + DEF_WING_LEN,          y1 = -DEF_WING_RISE;
          const cx =  x0 + DEF_WING_LEN * 0.55,   cy = -DEF_WING_RISE * 1.2;

          ctx.beginPath();
          ctx.lineCap = "round";
          ctx.moveTo(x0, y0);
          ctx.quadraticCurveTo(cx, cy, x1, y1);
          // @ts-ignore
          ctx.strokeStyle = shape.stroke();
          // @ts-ignore
          ctx.lineWidth = shape.strokeWidth();
          ctx.stroke();
        }}
        stroke={color}
        strokeWidth={DEF_WING_STROKE}
        listening={false}
      />
    </Group>
  );
};

export default DefenderGlyph;
